/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { classNames } from '@ember-decorators/component';

@classNames('goals-list', 'layout-column')
export default class GoalsList extends Component {
  @service
  router;

  onRouteTransition() {}

  @action
  goToRoute(route, params) {
    this.onRouteTransition();
    this.router.transitionTo(route, ...params);
  }
}
